import { ReactNode } from 'react';
import { isArray } from 'lodash';
import { FsRawNode } from '~/api/types';
import FolderTreeItem from '../components/FolderTreeItem';

interface TreeViewApiRef {
  current?: {
    getItemDOMElement?: (itemId: string) => HTMLElement | null;
  } | null;
}

export const buildFolderTreeNodes = (node: FsRawNode): ReactNode => {
  if (!node.is_dir) return null;

  const folderChildren = node.children?.filter((c) => c.is_dir) ?? [];

  return (
    <FolderTreeItem node={node} key={node.path}>
      {folderChildren.map(buildFolderTreeNodes)}
    </FolderTreeItem>
  );
};

export const getFilesInFolder = (folder: FsRawNode | null): FsRawNode[] => {
  if (!folder) return [];
  if (isArray(folder)) return folder.filter((node) => !node.is_dir);

  return folder.children?.filter((child) => !child.is_dir) ?? [];
};

export const setItemSelection = (apiRef: TreeViewApiRef, itemId: string, isSelected: boolean) => {
  if (apiRef.current && apiRef.current.getItemDOMElement) {
    const element = apiRef.current.getItemDOMElement(itemId);
    if (element) {
      element.setAttribute('aria-selected', isSelected.toString());
      const childElement = element.querySelector('.MuiTreeItem-content');
      if (childElement) {
        childElement.setAttribute('data-selected', isSelected.toString());
      }
    }
  }
};
